const StudentCardSkeleton = () => {
  return (
    <div
      className="w-full space-y-3 mt-4"
      role="list"
      aria-label="Loading students"
    >
      {[...Array(6)].map((_, index) => (
        <div
          key={index}
          className="@container rounded border border-[#DDDDDD] bg-white px-3 py-2 sm:py-3 2xl:pl-8 2xl:pr-3 flex flex-row items-center justify-between gap-2 sm:gap-3 animate-pulse"
        >
          <div className="grid grid-cols-2 sm:grid-cols-4 items-start gap-2 sm:gap-3 w-full min-w-0">
            {/* col 1: name + class */}
            <div className="col-span-1 w-full min-w-0">
              <div className="h-4 sm:h-5 bg-gray-200 rounded w-28 sm:w-36 mb-2" />
              <div className="h-3 sm:h-4 bg-gray-200 rounded w-24 sm:w-32" />
            </div>

            {/* col 2: latest alert */}
            <div className="col-span-1 w-full min-w-0">
              <div className="h-4 bg-gray-200 rounded w-24 sm:w-28 mb-2" />
              <div className="h-3 sm:h-4 bg-gray-200 rounded w-36 sm:w-48" />
            </div>

            {/* col 3: last emotion */}
            <div className="col-span-1 w-full min-w-0">
              <div className="h-3 sm:h-4 bg-gray-200 rounded w-32 sm:w-40" />
            </div>

            {/* col 4: emotion pattern */}
            <div className="col-span-1 w-full min-w-0">
              <div className="h-3 sm:h-4 bg-gray-200 rounded w-32 sm:w-40" />
            </div>
          </div>
          <div className="w-6 h-6 bg-gray-200 rounded flex-shrink-0" />
        </div>
      ))}
    </div>
  );
};

export default StudentCardSkeleton;
